<template>
  <div class="__head-contents">
    <CPageTitle class="report-filters-title" :title="$t('Report Filters')" />

    <DropdownMenu :items="menuItems" autoClose @click="onClickActionMenu" />
  </div>
</template>
<script>
import CButton from '@alphauslabs/alphaus-design-system/src/components/Button';
import CPageTitle from '@/components/uikit/CPageTitle';
import DropdownMenu from '@design-system/components/DropdownMenu.vue';
const messages = {
  en: {
    'Create Filter': 'Create Filter',
    'Edit Selected Filter': 'Edit Selected Filter',
    'Delete Selected Filter': 'Delete Selected Filter',
  },
  ja: {
    'Create Filter': 'フィルターを作成',
    'Edit Selected Filter': '選択しているフィルターを編集',
    'Delete Selected Filter': '選択しているフィルターを削除',
  },
};
export default {
  name: 'HeadContents',
  i18n: { messages },
  components: { CButton, CPageTitle, DropdownMenu },
  props: ['disableEdit', 'disableDelete'],
  computed: {
    menuItems() {
      return [
        {
          key: 'create',
          label: this.$t('Create Filter'),
          icon: 'o_add',
          disabled: false,
        },
        {
          key: 'edit',
          label: this.$t('Edit Selected Filter'),
          icon: 'o_edit',
          disabled: this.disableEdit,
        },
        {
          key: 'delete',
          label: this.$t('Delete Selected Filter'),
          color: 'danger',
          icon: 'o_delete',
          disabled: this.disableDelete,
        },
      ].filter(item => !item.disabled);
    },
  },
  methods: {
    onClickActionMenu(val) {
      this.$emit('click-action', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.__head-contents {
  padding-left: $space-md;
  padding-right: $space-md;
  padding-top: $space-md;
  display: flex;
  justify-content: space-between;
  word-break: break-all;
  margin-bottom: $space-xs;
  &-ActionButtons {
    display: flex;
    & > div {
      margin-right: $space-xs;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .report-filters-title {
    margin-bottom: $space-xs;
  }
}
</style>
